import { Autocomplete, Container, Grid, TextField, ThemeProvider, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Footer } from './Footer';
import { Header } from './header';
import { KinaseGrid } from './KinaseGrid';
import { Data, Node, NodeType } from './models';
import { theme } from './theme';

export function Kinase() {
  const [data, setData] = useState<Data>();
  const [options, setOptions] = useState<Array<Node>>([])
  const [selected, setSelected] = useState<Array<Node>>([]);
  const [filteredData, setFilteredData] = useState<Array<any> | null>(null);

  useEffect(() => {
    (async () => {
      const data = new Data();
      setData(await data.load());
    })()
  }, [])

  useEffect(() => {
    setSelected([]);
    if (!data) return;
    setOptions(data.getNodesByType(NodeType.CYTOKINE).map(v => new Node(NodeType.CYTOKINE + "_" + v)));
    setFilteredData(null)
  }, [data])

  useEffect(() => {
    data && setFilteredData(data.filterForKinases(selected))
  }, [data, selected])

  return (
    <ThemeProvider theme={theme}>
      <Container sx={{ minHeight: `calc(100vh - 301px)` }}>
        <Grid container spacing={2}>
          <Header label="Kinases Discovery" home={true} />
          <Grid item xs={12} sm={8}>
            <Typography variant='body1' style={{ paddingBottom: '30px' }}>
              Enter the name of cytokine(s) to determine kinase(s) that might act as upstream mediators. A table displaying 
              a comprehensive list of kinases related to one or more of the cytokines of interest will be generated. For 
              each kinase listed, the table will include information about the number of cytokines of interest impacted 
              and additional cytokines that could be affected.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={8}>
            <Typography variant='h2' sx={{ mb: 2 }}>Search</Typography>
            <Autocomplete
              clearOnEscape
              options={options}
              multiple={true}
              value={selected}
              getOptionLabel={(option) => { return option.name }}
              renderInput={(params) => <TextField {...params} label="Enter Cytokines" />}
              onChange={(event, newValue) => {
                setSelected(newValue);
              }}
            />
          </Grid>
          {(filteredData && filteredData.length) ? (
            <Grid item xs={12}>
              {filteredData && <KinaseGrid filteredData={filteredData} selected={selected} />}
            </Grid>) : (
            <Grid item xs={12}>
              <Typography variant='body2' color="secondary">
                Enter one or more Cytokines to view Kinases
              </Typography>
            </Grid>
          )}
        </Grid>
      </Container >
      <Footer />
    </ThemeProvider >

  );
}

export default Kinase;